import { OnboardingPushApi } from '@psl/generated/api';
import configuration from './configuration';

export default new OnboardingPushApi(configuration);
